let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eMkc9")).then(() => parcelRequire('l1pXD'));